import { render, staticRenderFns } from "./AccordionTab.vue?vue&type=template&id=4b5b6b35"
import script from "./AccordionTab.vue?vue&type=script&lang=js"
export * from "./AccordionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports